<template>
    <section class="index-your-instrument">
        <div class="index-your-instrument__content">
            <h2 class="index-your-instrument__title">
                <span class="c-blue-600">Market Brains</span> — ваш главный инструмент для успеха на маркетплейсах
            </h2>

            <p class="index-your-instrument__text">
                Сервис помогает продавцам легко управлять товарами, отслеживать динамику рынка и находить новые точки роста.
            </p>
        </div>

        <div class="index-your-instrument__image">
            <div class="index-your-instrument__white-block" />
            <div class="index-your-instrument__image-wrapper">
                <WBImage class="index-your-instrument__image-content"
                         aspect-ratio="38,11"
                         src="/images/index-page/your-instrument/mb-screenshot.png"
                         alt=""
                />
            </div>
            <div class="index-your-instrument__gradient" />
        </div>
    </section>
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">
.index-your-instrument {
        padding-top: 120px;

        @include respond-to(tablet) {
            padding-top: 80px;
        }

        @include respond-to(mobile) {
            padding-top: 40px;
        }

        &__content {
            max-width: 917px;
            margin: 0 auto;

            @include respond-to(tablet) {
                max-width: 704px;
            }
        }

        &__title {
            @include mulish40b;

            text-align: center;

            @include respond-to(tablet) {
                @include mulish32b;
            }

            @include respond-to(mobile) {
                @include mulish24b;
            }
        }

        &__text {
            @include mulish18r;

            margin-top: 20px;
            text-align: center;
        }

        &__image {
            position: relative;
            margin-top: 88px;

            @include respond-to(tablet) {
                margin-top: 80px;
            }

            @include respond-to(mobile) {
                margin-top: 40px;
            }
        }

        &__image-wrapper {
            position: relative;
            z-index: 1;
            width: 100%;
            height: 374px;
            margin: 0 auto;
            aspect-ratio: 38/11;

            @include respond-to(tablet) {
                max-width: 100%;
                height: auto;
            }
        }

        &__image-content {
            position: absolute;
            left: 50%;
            width: 100%;
            height: 100%;
            transform: translateX(-50%);
        }

        &__white-block {
            position: absolute;
            bottom: 20px;
            left: 50%;
            z-index: 0;
            width: 100%;
            max-width: 100%;
            height: 193px;
            background-color: var(--white);
            border-top-left-radius: 30px;
            border-top-right-radius: 30px;
            transform: translateX(-50%);

            @include respond-to(tablet) {
                max-width: calc(100% - 46px);
                height: 50%;
            }
        }

        &__gradient {
            position: absolute;
            bottom: 0;
            z-index: 2;
            width: 100%;
            height: 173px;
            background: linear-gradient(180deg, rgb(255 255 255 / 0%) 0%, #E6EAF5 100%);

            @include respond-to(tablet) {
                height: 146px;
            }

            @include respond-to(mobile) {
                height: 79px;
            }
        }
    }
</style>
